//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_wishlist

class AddToWishListEventListener {
    // Language: javascript
    // Path: AddToWishListEventListener.js
    // Compare this snippet from EventListener.js:

    constructor(element, eventName = "click") {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var analyticsData = this.dataset.analytics
            ? JSON.parse(this.dataset.analytics)
            : null;

        if (analyticsData && this.dataset) {
            var analticsDataProducts = analyticsData.products
                ? analyticsData.products[0]
                : null;

            var cartAmount = document.querySelector(
                '[name="addToCartAmount"][data-id="' +
                    analticsDataProducts.id +
                    '"]'
            );
            var addToCartAmount = cartAmount
                ? cartAmount.value
                : document.querySelector(
                      '[name="addToCartAmount"][data-id="' +
                          this.dataset.id +
                          '"]'
                  );
            var quantity = parseFloat($(addToCartAmount).val());
            var item_list_id = "base";

            var price = Number(
                analticsDataProducts.price
                    ? analticsDataProducts.price.replace(",", ".")
                    : this.dataset.price
            ).toFixed(2);
            var pricewithdiscount = Number(
                analticsDataProducts.pricewithdiscount
                    ? analticsDataProducts.pricewithdiscount.replace(",", ".")
                    : this.dataset.priceWithDiscount.replace(",", ".")
            ).toFixed(2);

            var item = {
                item_id: analticsDataProducts.code,
                item_name: analticsDataProducts.name,
                currency: analticsDataProducts.currency
                    ? analticsDataProducts.currency
                    : this.dataset.currency,
                item_brand: analticsDataProducts.brand,
                item_category: analticsDataProducts.category,
                item_list_id: item_list_id,
                price: pricewithdiscount,
                quantity: quantity ? quantity : this.dataset.quantity,
            };
            if (analticsDataProducts.categories) {
                var splitCategories =
                    analticsDataProducts.categories.split(";");
                for (var i = 0; i < splitCategories.length; i++) {
                    if (i == 0) {
                        item["item_category"] = splitCategories[i];
                    } else {
                        item["item_category" + i] = splitCategories[i];
                    }
                }
            }
            if (this.dataset.addtype) {
                item["item_list_id"] = this.dataset.addtype;
            }

            if (this.dataset.variant) {
                var variant = JSON.parse(this.dataset.variant);
                if (variant) {
                    item["item_variant"] = Object.values(variant).join(",");
                }
            }
            if (price != pricewithdiscount) {
                item["price"] = price;
                item["discount"] = (price - pricewithdiscount).toFixed(2);
            }

            dataLayer
                .push({
                    // eslint-disable-line
                    event: "add_to_wishlist",
                    ecommerce: {
                        items: [item],
                    },
                })
                .then(() => {
                    console.log("GTM pushed add_to_wishlist event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 1000);
                })
                .catch((error) => {
                    console.warn("GTM error add_to_wishlist event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "add_to_wishlist", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "add to wishlist",
                    items: [item],
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            AddToWishListEventListener.prototype.callback
        );
    }
    remove() {
        this.element.removeEventListener(
            this.eventName,
            AddToWishListEventListener.prototype.callback
        );
    }
}
